import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as InvoiceActions from './payments.actions';
import { catchError, exhaustMap, filter, map, switchMap, tap } from 'rxjs/operators';
import { PaymentService } from '@app/services/payment.service';
import { of } from 'rxjs';

@Injectable()
export class PaymentsEffects {
    loadPaymentForm$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InvoiceActions.loadGuestPayment),
            filter(action => !!action.guestPaymentRequest),
            switchMap((action) =>
                this.paymentService.getGuestPayment$(action.guestPaymentRequest).pipe(
                    map((guestPayment) => InvoiceActions.loadGuestPaymentSuccess({ guestPayment })),
                    catchError((err) => of(InvoiceActions.loadGuestPaymentFailed({ guestPaymentError: err.error })))
                )
            )
        )
    );

    loadTransaction$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InvoiceActions.loadTransaction),
            switchMap((action) => this.paymentService.getTransactionBySessionId$(action.sessionId, action.verification)),
            map((transaction) => InvoiceActions.loadTransactionSuccess({ transaction }))
        ));

    constructor(
        private actions$: Actions,
        private paymentService: PaymentService) {
    }
}
